import { useEffect } from 'react'
import { useLocation } from 'wouter'

/**
 * `/drivers` sends the browser to `/delivery-statistics`.
 *
 * The drivers page was folded into the statistics screen, and legacy kept the
 * path as a redirect. Ported for the same reason `/orders` → `/lists` was: the
 * URL is in bookmarks and in links people pasted into chat.
 *
 * `replace`, so the back button leaves rather than bouncing off the redirect.
 *
 * **Until `/delivery-statistics` lands this arrives at the not-found page.** That
 * page needs a chart dependency the workspace has not pinned — see
 * `docs/DECISIONS.md`. The redirect is faithful; its destination is owed.
 */
export function DriversRedirect() {
  const [, navigate] = useLocation()

  useEffect(() => {
    navigate('/delivery-statistics', { replace: true })
  }, [navigate])

  return null
}
